import React, {memo} from 'react';
import {ItemList} from '../ItemList';
import {useFilterSelector} from '../../hooks/filter-selector';
import {useDispatch} from "react-redux";
import { setGroupControlsAction} from "../../store/control/actions";
export const ControlRenderer = memo(function ControlRenderer(props: { controlTypeId: string }) {
    const dispatch = useDispatch();
    const controls = useFilterSelector(
        state => state.control.controlList,
        c => c.type_id === props.controlTypeId
    ).sort((a, b) => (a?.parameters?.["order"] > b?.parameters?.["order"] ? 1 : -1))
    dispatch(setGroupControlsAction(controls));
    return <ItemList controls={controls}/>
});
